import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DirectsPositionClassComparison } from '../../../models/directs-position-class-comparison.model';

@Component({
  selector: 'customer-directs-position-comparison-list',
  templateUrl: './directs-position-comparison-list.component.html',
  styleUrls: ['./directs-position-comparison-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DirectsPositionComparisonListComponent {
  readonly comparisonEmployees = input.required<DirectsPositionClassComparison[]>();
}
